module.exports = __webpack_public_path__ + "img/tidus.fd3db8a5.svg";